export { withServerSideRendering } from './server-components.tsx';
